<template>
  <div>
    <div>
      <div class="menu">
        <a href="/company" class="logo cursor-pointer">
          <img src="@/assets/images/logo-up.png" />
        </a>
        <!-- :contractStatus="contractStatus" -->
        <MenuItems
          :company="this.company"
          :menuSelected="this.menuSelected"
          :user="this.user"
        />
      </div>

      <div class="menu-mobile">
        <div class="user-mobile">
          <div class="close-menu" @click="openMenu(false)">
            <img src="@/assets/images/x.svg" />
          </div>

          <div>
            <img src="@/assets/images/settings.png" />
          </div>
          <div>
            <a href="#">{{ this.company.name | titleCase }}</a>
          </div>
        </div>
        <!-- :contractStatus="contractStatus" -->
        <MenuItems
          :company="this.company"
          :menuSelected="this.menuSelected"
          :user="this.user"
        />
      </div>

      <div class="container-right">
        <div
          class="barTop"
          :class="menuSelected.dashboard ? 'view' : 'bar-top-white'"
        >
          <div class="logo-mobile" v-if="menuSelected.dashboard">
            <img src="@/assets/images/logo-up.png" />
          </div>
          <div
            class="menu-white"
            v-if="menuSelected.dashboard"
            @click="openMenu(true)"
          >
            <img src="@/assets/images/menu-burger-alb.svg" />
          </div>

          <div class="mobile-nav" v-if="!menuSelected.dashboard">
            <div class="arrow-back" @click="goBack()">
              <img src="@/assets/images/arrow-back.svg" />
            </div>
            <div class="page-title">
              <h3>{{ this.getPageTitle() }}</h3>
            </div>
            <div class="menu-white" @click="openMenu(true)">
              <img src="@/assets/images/menu-burger-gri.svg" />
            </div>
          </div>
          <TopBar :company="this.company" :user="this.user" />
        </div>

        <div
          class="content"
          :class="this.menuSelected.search && 'dashboard-beneficiary'"
        >
          <BankReport v-if="this.menuSelected.bank_report" :userRole="this.company.role"  />
          <ClientMandate v-if="this.menuSelected.client_mandate" :userRole="this.company.role" />
          <ClientInvoice v-if="this.menuSelected.payments" :user="this.user" />
          <FinanceAccount v-if="this.menuSelected.account" :companyDetails="this.company" :user="this.user" :userRole="this.company.role"/>

        </div>
      </div>
    </div>
    <div id="modal_popup_loading" class="modal-popup">
      <div class="modal-popup-content">
        <img src="@/assets/images/loading.gif" />
        <p v-html="$t('loadingPopupMessage')">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment/src/moment";
  import MenuItems from "@/components/company/finance/MenuItems.vue";
  import TopBar from "@/components/company/TopBar.vue";
  import BankReport from "@/components/company/finance/BankReport.vue";
  import ClientMandate from "@/components/company/finance/ClientMandate.vue";
  import ClientInvoice from "@/components/company/finance/ClientInvoice.vue";
  import FinanceAccount from "@/components/company/finance/FinanceAccount.vue";

  import $ from "jquery";

  export default {
    components: {
      MenuItems,
      TopBar,
      BankReport,
      ClientMandate,
      ClientInvoice,
      FinanceAccount,
    },
    props: {
      user: Object,
      company: Object
    },
    data() {
      return {
        flexben: {
          hasAccess: false
        },
        menuSelected: {
          bank_report: false,
          client_mandate: false,
          account: false,
          Clipayments: false,
        },

        isOpen: false,
        config: JSON.parse(sessionStorage.getItem("client_jsonFile"))
      };
    },
    methods: {
      openMenu(open) {
        if (open) {
          $(".menu-mobile").show();
        } else {
          $(".menu-mobile").hide();
        }
      },
      openUserMenu() {
        this.isOpen = !this.isOpen;
      },
      hide() {
        this.isOpen = false;
      },
      hideNotification() {
        this.isOpenNotification = false;
      },
      getPageTitle() {
        if (this.menuSelected.bank_report) {
          return "Raport bancar";
        } else if (this.menuSelected.client_mandate) {
          return "Mandat Clienti";
        } else if (this.menuSelected.payments) {
          return "Plati clienti";
        } else if (this.menuSelected.account) {
          return "Setari cont";
        } else {
          return "Raport bancar";
        }
      },
      goBack() {
        window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
      },
      getExpireAmountDateFormat(date) {
        return moment(new Date(date), "YYYY-MM-DD").format("DD MMM YYYY");
      },
    },
    mounted() {
      // prevent click outside event with popupItem.
      if (!sessionStorage.getItem("client_jsonFile")) {
      }
    },
    created() {
      console.log(this.$route.name);
      switch (this.$route.name) {
        case "finance_bank_report":
          this.menuSelected.bank_report = true;
          break;
        case "finance_client_mandate":
          this.menuSelected.client_mandate = true;
          break;
        case "finance_payment":
          this.menuSelected.payments = true;
          break;
        case "finance_account":
          this.menuSelected.account = true;
          break;
        default:
          this.menuSelected.bank_report = true;
      }
    }
  };
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
